// ─────────────────────────────────────────────────────────────
// SITE IMAGES — one-off photography used across the website.
// Each key is labeled with the EXACT place it appears, so you
// can swap any photo by editing the URL string here.
// (Collection/portfolio photos live in projects.js,
//  builder carousel photos live in builderProjects.js.)
// Every image below has been visually verified as
// kitchen/joinery relevant.
// ─────────────────────────────────────────────────────────────

export const SITE_IMAGES = {
  // Hero — cinematic full-screen background at the top of the site
  hero: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2400&q=85",

  // "Who we work with" split-screen — left card (Homeowners)
  // Family in a warm, well-appointed kitchen w/ brass hardware.
  audiencesHomeowner:
    "https://images.pexels.com/photos/5082055/pexels-photo-5082055.jpeg?auto=compress&cs=tinysrgb&w=1800",
  // "Who we work with" split-screen — right card (Builders & Developers)
  // Draftsman sketching a joinery section detail — reads as bespoke.
  audiencesBuilder:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1800&q=85",

  // Emotional section ("Imagine walking into this every morning.") — large parallax image
  emotional:
    "https://images.pexels.com/photos/5082055/pexels-photo-5082055.jpeg?auto=compress&cs=tinysrgb&w=2400",

  // Craftsmanship section — 4 detail close-ups (Material / Precision / Hardware / Finish)
  craftMaterial:
    "https://images.pexels.com/photos/10486222/pexels-photo-10486222.jpeg?auto=compress&cs=tinysrgb&w=2000",
  craftPrecision:
    "https://images.unsplash.com/photo-1556912173-3bb406ef7e77?auto=format&fit=crop&w=2000&q=80",
  // Kitchen hardware — brass handles on wooden cabinet (verified close-up).
  craftHardware:
    "https://images.pexels.com/photos/35287566/pexels-photo-35287566.jpeg?auto=compress&cs=tinysrgb&w=2000",
  craftFinish:
    "https://images.pexels.com/photos/37030080/pexels-photo-37030080.jpeg?auto=compress&cs=tinysrgb&w=2000",

  // Process section — Kitchen & joinery specific:
  // Discover  = designer & clients reviewing tile samples in a kitchen
  processDiscover:
    "https://images.pexels.com/photos/8293677/pexels-photo-8293677.jpeg?auto=compress&cs=tinysrgb&w=1400",
  // Design    = architect drafting blueprints with ruler & pencil
  processDesign:
    "https://images.pexels.com/photos/6614837/pexels-photo-6614837.jpeg?auto=compress&cs=tinysrgb&w=1400",
  // Build     = joinery workshop, router shaping timber cabinet component
  processBuild:
    "https://images.pexels.com/photos/5711767/pexels-photo-5711767.jpeg?auto=compress&cs=tinysrgb&w=1400",
  // Install   = jigsaw cutting into a white kitchen base cabinet on site
  processInstall:
    "https://images.pexels.com/photos/15861553/pexels-photo-15861553.jpeg?auto=compress&cs=tinysrgb&w=1400",

  // Trade Partnership section ("Strictly Building" testimonial image)
  tradePartnership:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=2400&q=85",

  // Final CTA — luxury sunset kitchen at the bottom of the page
  cta: "https://images.pexels.com/photos/9843507/pexels-photo-9843507.jpeg?auto=compress&cs=tinysrgb&w=2400",
};
